import { useEffect, useState } from "react";
import request from "request";
import { AuthStatus } from "routes";
import { useDispatch } from "store/hooks";

export function useAuth(isLoginRoute: boolean) {
  const [authStatus, setAuthStatus] = useState<AuthStatus>("checking");
  const dispatch = useDispatch();

  useEffect(() => {
    const validateToken = async () => {
      if (isLoginRoute) {
        setAuthStatus("unauthenticated");
        return;
      }

      if (!localStorage.getItem("token")) {
        setAuthStatus("unauthenticated");
        return;
      }

      setAuthStatus("checking");

      try {
        const response = await request.get("validate_token");

        if (response.status === 200) {
          dispatch.user.INIT(response.data);
          setAuthStatus("authenticated");
        } else {
          if (response.status === 406) localStorage.clear();
          setAuthStatus("unauthenticated");
        }
      } catch {
        setAuthStatus("unauthenticated");
      }
    };

    validateToken();
  }, [dispatch, isLoginRoute]);

  return authStatus;
}